import { memo } from 'react';

import type { NewsTag } from '@/types/newsService';
import { cn } from '@/lib/cn';

interface Props {
  tags: NewsTag[];
  selectedIds: string[];
  onToggle: (tagId: string) => void;
}

/**
 * 2-column grid of selectable tag pills used on the preferences screen.
 * Ported from mobile-app/src/components/news/TagSelector.tsx.
 */
export const TagSelector = memo(function TagSelector({
  tags,
  selectedIds,
  onToggle,
}: Props) {
  return (
    <div className="grid grid-cols-2 gap-2.5 px-4">
      {tags.map((item) => {
        const isSelected = selectedIds.includes(item._id);
        return (
          <button
            key={item._id}
            type="button"
            onClick={() => onToggle(item._id)}
            className={cn(
              'flex items-center gap-2 rounded-[14px] border-2 bg-[#1e1e1e] px-3.5 py-3.5 transition-opacity active:opacity-80',
              isSelected ? 'border-brand bg-brand/10' : 'border-transparent',
            )}
            style={
              item.color && isSelected ? { borderColor: item.color } : undefined
            }
          >
            {item.icon ? <span className="text-lg">{item.icon}</span> : null}
            <span
              className={cn(
                'flex-1 text-left text-sm font-semibold',
                isSelected ? 'text-brand' : 'text-fg',
              )}
            >
              {item.name}
            </span>
            <span className="text-xs text-[#6a6a6a]">{item.articleCount}</span>
          </button>
        );
      })}
    </div>
  );
});
